export enum SseEventType {
  FILE_PATH_ERROR = "FILE_PATH_ERROR",
  FILE_PROCESS_ERROR = "FILE_PROCESS_ERROR",
  REFRESH_NEEDED = "REFRESH_NEEDED",
  INCORRECT_FILE_TYPE = "INCORRECT_FILE_TYPE",
  FILE_EXPORT_SUCCESS = "FILE_EXPORT_SUCCESS"
}
